/**
 *  Loại phương án phân bổ
 */
export default {
  Field: 1, // Lĩnh vực
  Source: 2, // Nguồn kinh phí
};
